import { render, staticRenderFns } from "./Managedigital.vue?vue&type=template&id=5430523f"
import script from "./Managedigital.vue?vue&type=script&lang=js"
export * from "./Managedigital.vue?vue&type=script&lang=js"
import style0 from "./Managedigital.vue?vue&type=style&index=0&id=5430523f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports